/**
 * Payment-method discounts (frontend mirror).
 *
 * Mirrors backend/config/paymentDiscounts.js — both files must agree on
 * the percentage. The backend is the source of truth for the actual
 * charge; this side is purely for display (badge copy, strike-through
 * pricing, savings line on the checkout page).
 */

export const CRYPTO_PAYMENT_DISCOUNT_PERCENT = 5;

/**
 * Apply the crypto-payment discount to a USD price (for display).
 * @param {number} usdPrice
 * @returns {number} Discounted price, rounded to 2 decimals
 */
export function applyCryptoDiscount(usdPrice) {
  const n = Number(usdPrice);
  if (!Number.isFinite(n) || n <= 0) return n;
  const multiplier = (100 - CRYPTO_PAYMENT_DISCOUNT_PERCENT) / 100;
  return Math.round(n * multiplier * 100) / 100;
}

/**
 * Resolve the display charge for a given payment method.
 * @param {number} usdPrice
 * @param {string | null | undefined} gatewaySlug
 * @returns {number}
 */
export function chargeAmountForGateway(usdPrice, gatewaySlug) {
  return gatewaySlug === "cryptorocket"
    ? applyCryptoDiscount(usdPrice)
    : Number(usdPrice);
}

/**
 * Savings amount (USD) for paying via crypto.
 * @param {number} usdPrice
 * @returns {number}
 */
export function cryptoSavings(usdPrice) {
  const n = Number(usdPrice);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.round(n * (CRYPTO_PAYMENT_DISCOUNT_PERCENT / 100) * 100) / 100;
}
